module.exports = __webpack_public_path__ + "static/media/logo6.4e7b2b38.png";